import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { ColumnFlex } from '~/components/basic/containers';
import { translate } from '~/services/translate';

const Title = styled.div`
  margin: 0 auto 4px;
  font-weight: 600;
  font-size: 24px;
`;

const HeaderContainer = styled(ColumnFlex)`
  height: 88px;
`;

const SubTitle = styled.div`
  margin: 0 auto 32px;
  font-size: 13px;
  line-height: 20px;
  ${props => props.shouldShow ? `display: flex;` : `display: none;`}
`;

const Header = ({ isSignUp }) => (
  <HeaderContainer>
    <Title>{isSignUp ? translate('sign_up_header') : translate('login')}</Title>
    <SubTitle shouldShow={isSignUp}>{translate('cancel_anytime')}</SubTitle>
  </HeaderContainer>
)

Header.propTypes = {
  isSignUp: PropTypes.bool,
}

export default Header;